import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { API_URL, authFetch } from "../../utils/auth";
import LeadDetailView from "../../partners/leads/LeadDetailPage";

export default function Lead() {
  const { leadId } = useParams();
  const [lead, setLead] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadLead() {
      try {
        setLoading(true);
        const response = await authFetch(`${API_URL}/partner/leads/${leadId}/`);
        const data = await response.json();
        if (!response.ok) throw new Error(data.detail || "Failed to load lead");
        setLead(data);
      } catch (err) {
        console.error(err);
        setError(err.message || "Failed to load lead");
      } finally {
        setLoading(false);
      }
    }

    loadLead();
  }, [leadId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!lead) return <div>Lead not found.</div>;
  if (lead.is_converted_client && lead.converted_client_id) {
    return <Navigate to={`/clients/${lead.converted_client_id}`} replace />;
  }

  return <LeadDetailView lead={lead} />;
}